import {} from '@chakra-ui/react'
import { ReactElement } from 'react'
import { useBreakpoint, useTheme } from 'utils'
import { IconButton, ListBulletIcon, MapIcon, Panel, Squares2X2Icon, Text, Tooltip } from '.'

interface Props {
  options: ViewType[]
  value: ViewType
  onChange: (value: ViewType) => void
}

export default function ViewSelector({ options, value, onChange }: Props) {
  const { theme } = useTheme()
  const isMobile = useBreakpoint() < 2
  return (
    <Panel direction="row" align="center" p={1} px={isMobile ? 1 : 4} h={9} gap={isMobile ? 0 : 1}>
      {!isMobile && <Text textStyle="bodySmall">View As: </Text>}
      {options.map(option => {
        const optionInfo = viewOptions[option]
        const isSelected = value === option

        return (
          <Tooltip key={option} positioning={{ placement: 'bottom' }} content={optionInfo.label}>
            <IconButton
              aria-label={option}
              icon={optionInfo.icon}
              borderRadius="sm"
              h="100%"
              onClick={() => onChange(option)}
              opacity={isSelected ? 1 : 0.3}
              bg={
                isSelected ? (theme === 'light' ? 'white' : 'rgba(255, 255, 255, 0.1)') : undefined
              }
              boxShadow={isSelected && theme === 'light' ? 'sm' : undefined}
            />
          </Tooltip>
        )
      })}
    </Panel>
  )
}

const viewOptions: Record<ViewType, ViewOption> = {
  grid: {
    label: 'Grid',
    icon: <Squares2X2Icon type="outline" />,
  },
  list: {
    label: 'List',
    icon: <ListBulletIcon />,
  },
  map: {
    label: 'Map',
    icon: <MapIcon type="outline" />,
  },
}

export type ViewType = 'grid' | 'list' | 'map'

interface ViewOption {
  label: string
  icon: ReactElement
}
